import { render, staticRenderFns } from "./ProjRepTotal.vue?vue&type=template&id=48597c05"
import script from "./ProjRepTotal.vue?vue&type=script&lang=js"
export * from "./ProjRepTotal.vue?vue&type=script&lang=js"
import style0 from "./ProjRepTotal.vue?vue&type=style&index=0&id=48597c05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports